import React from 'react';
import { SvgProps } from 'components/UI/Svg/Svg';

const Visa = {
  svg: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 1.34315 1.34315 0 3 0H61C62.6569 0 64 1.34315 64 3V39C64 40.6569 62.6569 42 61 42H3C1.34315 42 0 40.6569 0 39V3Z"
        fill="#F4F6F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 1.34315 1.34315 0 3 0H61C62.6569 0 64 1.34315 64 3V10H0V3Z"
        fill="#4095DB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 32H64V39C64 40.6569 62.6569 42 61 42H3C1.34315 42 0 40.6569 0 39V32Z"
        fill="#F4B662"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.2293 15.4879C38.6568 15.2546 37.7564 15 36.6348 15C33.7722 15 31.7572 16.5778 31.7404 18.8367C31.7222 20.5075 33.1784 21.4396 34.2761 21.995C35.4044 22.5643 35.7834 22.9286 35.779 23.4376C35.7712 24.2162 34.8784 24.5729 34.046 24.5729C32.8867 24.5729 32.2709 24.3973 31.3186 23.9633L30.9462 23.7782L30.5413 26.3804C31.2165 26.7042 32.4681 26.9852 33.7671 27C36.8094 27 38.7861 25.4415 38.8093 23.0292C38.8198 21.7042 38.0482 20.6996 36.3773 19.8704C35.3655 19.3315 34.7445 18.9744 34.7516 18.4288C34.7522 17.9455 35.2762 17.4284 36.4103 17.4284C37.3573 17.4126 38.0429 17.6387 38.5772 17.875L38.8372 18.008L39.2293 15.4879ZM25.8313 26.8276L27.6426 15.2026H30.538L28.7268 26.8276H25.8313ZM44.2381 19.4568C44.2381 19.4568 43.3246 22.0379 43.0847 22.7061H45.4884C45.374 22.1249 44.8184 19.3502 44.8184 19.3502L44.623 18.3476C44.5458 18.5776 44.4382 18.8823 44.3562 19.1143L44.3559 19.1152L44.3558 19.1156C44.2827 19.3225 44.2301 19.4712 44.2381 19.4568ZM46.6567 15.2144H44.4191C43.7251 15.2144 43.2056 15.4201 42.9015 16.1781L38.6017 26.8318H41.6428C41.6428 26.8318 42.1389 25.3986 42.2515 25.084C42.4074 25.084 43.1428 25.0854 43.9223 25.0868H43.9224L43.9228 25.0868C44.8017 25.0884 45.7365 25.09 45.96 25.09C46.0468 25.4957 46.3126 26.8318 46.3126 26.8318H49L46.6567 15.2144ZM23.4022 15.2124L20.5682 23.1379L20.2647 21.5268L19.2501 16.1853C19.075 15.4486 18.5663 15.2302 17.9375 15.2045H13.2683L13.2298 15.4453C14.3657 15.7464 15.3815 16.1806 16.2717 16.7205L18.8465 26.8175L21.9108 26.8156L26.4705 15.2124H23.4022Z"
        fill="#0071CE"
      />
    </g>
  ),
  viewBox: '0 0 64 42'
};

const MasterCard = {
  svg: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 1.34315 1.34315 0 3 0H61C62.6569 0 64 1.34315 64 3V39C64 40.6569 62.6569 42 61 42H3C1.34315 42 0 40.6569 0 39V3Z"
        fill="#F4F6F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 32C31.0751 32 36 27.0751 36 21C36 14.9249 31.0751 10 25 10C18.9249 10 14 14.9249 14 21C14 27.0751 18.9249 32 25 32Z"
        fill="#D8232A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 29.4857C33.9019 31.0564 36.3407 32 39 32C45.0751 32 50 27.0751 50 21C50 14.9249 45.0751 10 39 10C36.3407 10 33.9019 10.9436 32 12.5143C34.443 14.5319 36 17.5841 36 21C36 24.4159 34.443 27.4681 32 29.4857Z"
        fill="#ED9F2D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 12.5143C29.557 14.5319 28 17.5841 28 21C28 24.4158 29.557 27.468 32 29.4856C34.443 27.468 36 24.4158 36 21C36 17.5841 34.443 14.5319 32 12.5143Z"
        fill="#D8232A"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="28"
        y="12"
        width="8"
        height="18"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 12.5143C29.557 14.5319 28 17.5841 28 21C28 24.4158 29.557 27.468 32 29.4856C34.443 27.468 36 24.4158 36 21C36 17.5841 34.443 14.5319 32 12.5143Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27 13H37V14H27V13ZM27 15H37V16H27V15ZM37 17H27V18H37V17ZM27 19H37V20H27V19ZM37 21H27V22H37V21ZM27 23H37V24H27V23ZM37 25H27V26H37V25ZM27 27H37V28H27V27ZM37 29H27V30H37V29Z"
          fill="#ED9F2D"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 1.34315 1.34315 0 3 0H61C62.6569 0 64 1.34315 64 3V39C64 40.6569 62.6569 42 61 42H3C1.34315 42 0 40.6569 0 39V3Z"
        fill="#E5E5E5"
        fillOpacity="0.01"
      />
    </g>
  ),
  viewBox: '0 0 64 42'
};

const Amex = {
  svg: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 1.34315 1.34315 0 3 0H61C62.6569 0 64 1.34315 64 3V39C64 40.6569 62.6569 42 61 42H3C1.34315 42 0 40.6569 0 39V3Z"
        fill="url(#amex_radial)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 1.34315 1.34315 0 3 0H61C62.6569 0 64 1.34315 64 3V39C64 40.6569 62.6569 42 61 42H3C1.34315 42 0 40.6569 0 39V3Z"
        fill="#E5E5E5"
        fillOpacity="0.01"
      />
      <mask
        id="path-4-outside-1"
        maskUnits="userSpaceOnUse"
        x="7"
        y="15"
        width="51"
        height="12"
        fill="black"
      >
        <rect fill="white" x="7" y="15" width="51" height="12" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6569 21.9076L15.9906 18.972H16.0192L17.3099 21.9076H14.6569ZM14.872 17L11 25H13.2658L14.0689 23.2185H17.8979L18.6723 25H21.0098L17.1808 17H14.872ZM21.8989 17V25H24.007V19.3866H24.0357L26.5453 25H28.2805L30.7901 19.3305H30.8188V25H32.9269V17H29.7576L27.4918 22.5014H27.4631L25.0682 17H21.8989ZM34.9059 17V25H42.6785V23.521H37.1574V21.5602H42.1192V20.1933H37.1574V18.479H42.5638V17H34.9059ZM46.7083 20.8095L43.1374 25H45.6614L47.9416 22.2325L50.1787 25H52.8604L49.2896 20.8207L52.5736 17H50.107L48.0276 19.5546L46.0199 17H43.4099L46.7083 20.8095Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6569 21.9076L15.9906 18.972H16.0192L17.3099 21.9076H14.6569ZM14.872 17L11 25H13.2658L14.0689 23.2185H17.8979L18.6723 25H21.0098L17.1808 17H14.872ZM21.8989 17V25H24.007V19.3866H24.0357L26.5453 25H28.2805L30.7901 19.3305H30.8188V25H32.9269V17H29.7576L27.4918 22.5014H27.4631L25.0682 17H21.8989ZM34.9059 17V25H42.6785V23.521H37.1574V21.5602H42.1192V20.1933H37.1574V18.479H42.5638V17H34.9059ZM46.7083 20.8095L43.1374 25H45.6614L47.9416 22.2325L50.1787 25H52.8604L49.2896 20.8207L52.5736 17H50.107L48.0276 19.5546L46.0199 17H43.4099L46.7083 20.8095Z"
        fill="#1793C0"
        fillOpacity="0.01"
      />
      <path
        d="M14.6569 21.9076L12.836 21.0803L11.5515 23.9076H14.6569V21.9076ZM15.9906 18.972V16.972H14.7025L14.1697 18.1447L15.9906 18.972ZM16.0192 18.972L17.8501 18.167L17.3247 16.972H16.0192V18.972ZM17.3099 21.9076V23.9076H20.374L19.1408 21.1026L17.3099 21.9076ZM14.872 17V15H13.618L13.0718 16.1287L14.872 17ZM11 25L9.19977 24.1287L7.81007 27H11V25ZM13.2658 25V27H14.5581L15.0891 25.8219L13.2658 25ZM14.0689 23.2185V21.2185H12.7767L12.2456 22.3966L14.0689 23.2185ZM17.8979 23.2185L19.7321 22.4212L19.2093 21.2185H17.8979V23.2185ZM18.6723 25L16.8381 25.7973L17.3608 27H18.6723V25ZM21.0098 25V27H24.1843L22.8138 24.1366L21.0098 25ZM17.1808 17L18.9848 16.1366L18.4409 15H17.1808V17ZM21.8989 17V15H19.8989V17H21.8989ZM21.8989 25H19.8989V27H21.8989V25ZM24.007 25V27H26.007V25H24.007ZM24.007 19.3866V17.3866H22.007V19.3866H24.007ZM24.0357 19.3866L25.8615 18.5703L25.3323 17.3866H24.0357V19.3866ZM26.5453 25L24.7194 25.8163L25.2487 27H26.5453V25ZM28.2805 25V27H29.5824L30.1093 25.8095L28.2805 25ZM30.7901 19.3305V17.3305H29.4882L28.9613 18.521L30.7901 19.3305ZM30.8188 19.3305H32.8188V17.3305H30.8188V19.3305ZM30.8188 25H28.8188V27H30.8188V25ZM32.9269 25V27H34.9269V25H32.9269ZM32.9269 17H34.9269V15H32.9269V17ZM29.7576 17V15H28.4183L27.9083 16.2383L29.7576 17ZM27.4918 22.5014V24.5014H28.831L29.3411 23.2631L27.4918 22.5014ZM27.4631 22.5014L25.6293 23.2997L26.1524 24.5014H27.4631V22.5014ZM25.0682 17L26.902 16.2017L26.3788 15H25.0682V17ZM34.9059 17V15H32.9059V17H34.9059ZM34.9059 25H32.9059V27H34.9059V25ZM42.6785 25V27H44.6785V25H42.6785ZM42.6785 23.521H44.6785V21.521H42.6785V23.521ZM37.1574 23.521H35.1574V25.521H37.1574V23.521ZM37.1574 21.5602V19.5602H35.1574V21.5602H37.1574ZM42.1192 21.5602V23.5602H44.1192V21.5602H42.1192ZM42.1192 20.1933H44.1192V18.1933H42.1192V20.1933ZM37.1574 20.1933H35.1574V22.1933H37.1574V20.1933ZM37.1574 18.479V16.479H35.1574V18.479H37.1574ZM42.5638 18.479V20.479H44.5638V18.479H42.5638ZM42.5638 17H44.5638V15H42.5638V17ZM46.7083 20.8095L48.2305 22.1067L49.3448 20.7991L48.2203 19.5004L46.7083 20.8095ZM43.1374 25L41.6152 23.7028L38.8055 27H43.1374V25ZM45.6614 25V27H46.605L47.205 26.2718L45.6614 25ZM47.9416 22.2325L49.4969 20.9752L47.9563 19.0693L46.398 20.9607L47.9416 22.2325ZM50.1787 25L48.6233 26.2573L49.2237 27H50.1787V25ZM52.8604 25V27H57.1998L54.381 23.7008L52.8604 25ZM49.2896 20.8207L47.7729 19.5171L46.6557 20.8168L47.769 22.1199L49.2896 20.8207ZM52.5736 17L54.0903 18.3037L56.9299 15H52.5736V17ZM50.107 17V15H49.1561L48.5559 15.7374L50.107 17ZM48.0276 19.5546L46.4551 20.7905L48.0002 22.7564L49.5787 20.8172L48.0276 19.5546ZM46.0199 17L47.5924 15.7642L46.9918 15H46.0199V17ZM43.4099 17V15H39.0328L41.8979 18.3091L43.4099 17ZM16.4778 22.7348L17.8114 19.7993L14.1697 18.1447L12.836 21.0803L16.4778 22.7348ZM15.9906 20.972H16.0192V16.972H15.9906V20.972ZM14.1884 19.7769L15.479 22.7125L19.1408 21.1026L17.8501 18.167L14.1884 19.7769ZM17.3099 19.9076H14.6569V23.9076H17.3099V19.9076ZM13.0718 16.1287L9.19977 24.1287L12.8002 25.8713L16.6722 17.8713L13.0718 16.1287ZM11 27H13.2658V23H11V27ZM15.0891 25.8219L15.8922 24.0404L12.2456 22.3966L11.4425 24.1781L15.0891 25.8219ZM14.0689 25.2185H17.8979V21.2185H14.0689V25.2185ZM16.0637 24.0158L16.8381 25.7973L20.5065 24.2027L19.7321 22.4212L16.0637 24.0158ZM18.6723 27H21.0098V23H18.6723V27ZM22.8138 24.1366L18.9848 16.1366L15.3768 17.8634L19.2058 25.8634L22.8138 24.1366ZM17.1808 15H14.872V19H17.1808V15ZM19.8989 17V25H23.8989V17H19.8989ZM21.8989 27H24.007V23H21.8989V27ZM26.007 25V19.3866H22.007V25H26.007ZM24.007 21.3866H24.0357V17.3866H24.007V21.3866ZM22.2098 20.2028L24.7194 25.8163L28.3711 24.1837L25.8615 18.5703L22.2098 20.2028ZM26.5453 27H28.2805V23H26.5453V27ZM30.1093 25.8095L32.619 20.1401L28.9613 18.521L26.4517 24.1905L30.1093 25.8095ZM30.7901 21.3305H30.8188V17.3305H30.7901V21.3305ZM28.8188 19.3305V25H32.8188V19.3305H28.8188ZM30.8188 27H32.9269V23H30.8188V27ZM34.9269 25V17H30.9269V25H34.9269ZM32.9269 15H29.7576V19H32.9269V15ZM27.9083 16.2383L25.6425 21.7397L29.3411 23.2631L31.6069 17.7617L27.9083 16.2383ZM27.4918 20.5014H27.4631V24.5014H27.4918V20.5014ZM29.2969 21.7031L26.902 16.2017L23.2344 17.7983L25.6293 23.2997L29.2969 21.7031ZM25.0682 15H21.8989V19H25.0682V15ZM32.9059 17V25H36.9059V17H32.9059ZM34.9059 27H42.6785V23H34.9059V27ZM44.6785 25V23.521H40.6785V25H44.6785ZM42.6785 21.521H37.1574V25.521H42.6785V21.521ZM39.1574 23.521V21.5602H35.1574V23.521H39.1574ZM37.1574 23.5602H42.1192V19.5602H37.1574V23.5602ZM44.1192 21.5602V20.1933H40.1192V21.5602H44.1192ZM42.1192 18.1933H37.1574V22.1933H42.1192V18.1933ZM39.1574 20.1933V18.479H35.1574V20.1933H39.1574ZM37.1574 20.479H42.5638V16.479H37.1574V20.479ZM44.5638 18.479V17H40.5638V18.479H44.5638ZM42.5638 15H34.9059V19H42.5638V15ZM45.186 19.5123L41.6152 23.7028L44.6597 26.2972L48.2305 22.1067L45.186 19.5123ZM43.1374 27H45.6614V23H43.1374V27ZM47.205 26.2718L49.4851 23.5043L46.398 20.9607L44.1178 23.7282L47.205 26.2718ZM46.3862 23.4898L48.6233 26.2573L51.7341 23.7427L49.4969 20.9752L46.3862 23.4898ZM50.1787 27H52.8604V23H50.1787V27ZM54.381 23.7008L50.8101 19.5215L47.769 22.1199L51.3398 26.2992L54.381 23.7008ZM50.8063 22.1244L54.0903 18.3037L51.0569 15.6963L47.7729 19.5171L50.8063 22.1244ZM52.5736 15H50.107V19H52.5736V15ZM48.5559 15.7374L46.4765 18.2921L49.5787 20.8172L51.6581 18.2626L48.5559 15.7374ZM49.6001 18.3188L47.5924 15.7642L44.4474 18.2358L46.4551 20.7905L49.6001 18.3188ZM46.0199 15H43.4099V19H46.0199V15ZM41.8979 18.3091L45.1962 22.1187L48.2203 19.5004L44.9219 15.6909L41.8979 18.3091Z"
        fill="white"
        mask="url(#path-4-outside-1)"
      />
      <defs>
        <radialGradient
          id="amex_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(21.4922 7.96094) rotate(90) scale(42 64)"
        >
          <stop stopColor="#71C8F2" />
          <stop offset="1" stopColor="#0071BD" />
        </radialGradient>
      </defs>
    </g>
  ),
  viewBox: '0 0 64 42'
};

const Discover = {
  svg: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 1.34315 1.34315 0 3 0H61C62.6569 0 64 1.34315 64 3V39C64 40.6569 62.6569 42 61 42H3C1.34315 42 0 40.6569 0 39V3Z"
        fill="url(#discover0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 1.34315 1.34315 0 3 0H61C62.6569 0 64 1.34315 64 3V39C64 40.6569 62.6569 42 61 42H3C1.34315 42 0 40.6569 0 39V3Z"
        fill="#E5E5E5"
        fillOpacity="0.01"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7791 22.7825C12.3288 23.1919 11.7436 23.3705 10.8173 23.3705H10.4326V18.4799H10.8173C11.7436 18.4799 12.3058 18.6468 12.7791 19.0782C13.2749 19.5222 13.5731 20.2108 13.5731 20.9191C13.5731 21.6291 13.2749 22.3385 12.7791 22.7825M11.1044 17.2271H9.00003V24.6222H11.0933C12.2064 24.6222 13.0103 24.3582 13.7156 23.7685C14.5541 23.0705 15.0499 22.0182 15.0499 20.9299C15.0499 18.7473 13.4294 17.2271 11.1044 17.2271"
        fill="#212D34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7095 24.6224H17.1431V17.2269H15.7095V24.6224Z"
        fill="#212D34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6486 20.0649C19.7883 19.7446 19.5358 19.5334 19.5358 19.1337C19.5358 18.668 19.9859 18.314 20.6038 18.314C21.0331 18.314 21.3863 18.4917 21.7597 18.9129L22.5099 17.9246C21.8935 17.382 21.156 17.1049 20.3502 17.1049C19.0497 17.1049 18.0579 18.0134 18.0579 19.2237C18.0579 20.2426 18.5196 20.7643 19.8661 21.2517C20.4274 21.4511 20.7131 21.5837 20.857 21.6729C21.1436 21.8611 21.2869 22.1277 21.2869 22.4383C21.2869 23.0374 20.8136 23.4814 20.1739 23.4814C19.4901 23.4814 18.9392 23.1371 18.6093 22.4949L17.683 23.3923C18.3435 24.368 19.1369 24.8003 20.2278 24.8003C21.7174 24.8003 22.7626 23.8034 22.7626 22.372C22.7626 21.1969 22.2794 20.6651 20.6486 20.0649"
        fill="#212D34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.2148 20.9297C23.2148 23.1034 24.9112 24.7888 27.0942 24.7888C27.7112 24.7888 28.2399 24.6668 28.8916 24.358V22.66C28.3186 23.2371 27.8109 23.47 27.1609 23.47C25.717 23.47 24.6922 22.4165 24.6922 20.9188C24.6922 19.4991 25.7494 18.3791 27.0942 18.3791C27.7779 18.3791 28.2956 18.6245 28.8916 19.2111V17.514C28.2623 17.1928 27.745 17.0597 27.128 17.0597C24.956 17.0597 23.2148 18.7794 23.2148 20.9297"
        fill="#212D34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.2586 22.1944L38.2987 17.2269H36.7325L39.8514 24.8121H40.6229L43.798 17.2269H42.2439L40.2586 22.1944Z"
        fill="#212D34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.4463 24.6222H48.5119V23.3702H45.8788V21.3739H48.415V20.1214H45.8788V18.4799H48.5119V17.2268H44.4463V24.6222Z"
        fill="#212D34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.3121 20.6317H50.8933V18.3919H51.3348C52.2278 18.3919 52.7131 18.7682 52.7131 19.4879C52.7131 20.2314 52.2278 20.6317 51.3121 20.6317M54.1882 19.4102C54.1882 18.0257 53.2404 17.2268 51.5872 17.2268H49.4613V24.6222H50.8933V21.6514H51.0804L53.0646 24.6222H54.8277L52.5138 21.5068C53.5936 21.2857 54.1882 20.5425 54.1882 19.4102"
        fill="#212D34"
      />
      <g filter="url(#discover_filter)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.1795 20.9501C37.1795 23.123 35.4289 24.8844 33.2695 24.8844C31.11 24.8844 29.3597 23.123 29.3597 20.9501C29.3597 18.7773 31.11 17.0161 33.2695 17.0161C35.4289 17.0161 37.1795 18.7773 37.1795 20.9501"
          fill="url(#discover1_linear)"
        />
      </g>
      <defs>
        <filter
          id="discover_filter"
          x="29.3597"
          y="17.0161"
          width="7.81972"
          height="7.86829"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.314068 0 0 0 0 0.00146228 0 0 0 0 0.00146228 0 0 0 0.5 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <linearGradient
          id="discover0_linear"
          x1="-32"
          y1="21"
          x2="6.53106"
          y2="79.714"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF1F3" />
          <stop offset="1" stopColor="#D3DADF" />
        </linearGradient>
        <linearGradient
          id="discover1_linear"
          x1="38.0591"
          y1="21.7022"
          x2="33.4194"
          y2="16.2149"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFA700" />
          <stop offset="1" stopColor="#E75A10" />
        </linearGradient>
      </defs>
    </g>
  ),
  viewBox: '0 0 64 42'
};

const Default = {
  svg: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 1.34315 1.34315 0 3 0H61C62.6569 0 64 1.34315 64 3V39C64 40.6569 62.6569 42 61 42H3C1.34315 42 0 40.6569 0 39V3Z"
        fill="url(#paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 1.34315 1.34315 0 3 0H61C62.6569 0 64 1.34315 64 3V39C64 40.6569 62.6569 42 61 42H3C1.34315 42 0 40.6569 0 39V3Z"
        fill="#E5E5E5"
        fillOpacity="0.01"
      />
      <rect y="10" width="64" height="6" fill="#C4C4C4" />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="-32"
          y1="21"
          x2="6.53106"
          y2="79.714"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF1F3" />
          <stop offset="1" stopColor="#D3DADF" />
        </linearGradient>
      </defs>
    </g>
  ),
  viewBox: '0 0 64 42'
};

const CreditCard = (props?: SvgProps) => {
  if (!props) return Default;

  switch (props.children) {
    case 'visa':
      return Visa;
    case 'mastercard':
      return MasterCard;
    case 'amex':
      return Amex;
    case 'discover':
      return Discover;
    default:
      return Default;
  }
};

CreditCard.Default = Default;
CreditCard.Visa = Visa;
CreditCard.MasterCard = MasterCard;
CreditCard.Amex = Amex;
CreditCard.Discover = Discover;

export default CreditCard;
